if (!customElements.get("product-compatibility")) {
	class ProductCompatibility extends HTMLElement {
		constructor() {
			super(),
			this.selectors = {
				compatibility: [".product-compatibility"]
			},
			this.domNodes = queryDomNodes(this.selectors, this)
		}
		connectedCallback() {
			this.productId = this.dataset.productId,
			this.handleVariantChange()
		}
		handleVariantChange() {
			window.HimiEvents.subscribe(`${this.productId}__VARIANT_CHANGE`, (variant) => {
				if (variant) {
					this.domNodes.compatibility.forEach( e=>{
						e.dataset.variant == variant.id? e.classList.remove('hidden'):e.classList.add('hidden')
					})
				}
			}
			)
		}
	}
	customElements.define("product-compatibility", ProductCompatibility)
}